stage.verExternal="1.2.2";
// stage.languageId=6;
stage.languageList="nl,en";//支持的国际化种类
stage.loc.customer="Bliq";//oem客户的名称
stage.loc.customerDisplay="Bliq";//用来展示的定制化名称
$.extend(true,stage.loc,{
	key:{
		google:"AIzaSyBYU8ULYLFlMvsJoRkJBgJAxZ5RS7eleXg"
	},
	logo:{//logo地址
		login:{public:`/static/oem/${stage.loc.customer}/image/logo.png`},
		system:{public:`/static/oem/${stage.loc.customer}/image/logo.png`}
	},
	customerDisplay:{//用来展示的定制化名称
		public:"Bliq"
	}
	// privacyStatementUrl:""//隐私声明链接
});
$.extend(true,stage.setting.loc,{//功能屏蔽
	privacyStatementUrl:{
		public:"https://bliq.energy/algemene-voorwaarden/"
	},
	privacyPolicyUrl:{
		public:"https://bliq.energy/privacybeleid/"
	},
	shieldBlackList:{
		message:true,//消息功能
		inspect:true,//体检
		maintenance:true,//维保记录
		report:true,//报表
		plantPhoto:true,//电站照片
		networking:true,//组网应用
		managemessage:true //报警消息
	},
	AC_name:{
		title:'oem1',	//交流
		list:['1','2','3']
	}
});
$.extend(true,stage.color,{//配置js的颜色系统
	main:"#54d39d",
	blueLight:"#a6c9dd",
	blueDark:"#001f4e",
	redLight:"#f59fa7",
	// red: "#ff595f",
	redDark:"#da4658",
	yellowLight:"#fcce06",
	yellowDark:"#fb9678",
	// green: "#21ad5c",
	greenLight: "#54d39d",
	greenDark:"#30c790",
	// orange: "#fc7304",
	primary:"#001f4e",
	danger:"#fcce06",
	warning:"#f59fa7",
	success:"#a6c9dd",
	list: ["#a6c9dd", "#fcce06", "#f59fa7", "#2b684e", "#5383ed", "#ff595f", "#fb9678", "#30c790"]
});
// stage.languageId=2;//设置默认语言



// WEBPACK FOOTER //
// ./src/oem/js/Bliq.js